import { render } from "./RegistroPage.vue?vue&type=template&id=316f26b6&scoped=true"
const script = {}

import "./RegistroPage.vue?vue&type=style&index=0&id=316f26b6&scoped=true&lang=css"

import exportComponent from "D:\\mnry7\\Documents\\front-saberes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316f26b6"]])

export default __exports__